export const categories = [
  { id: 'dianying', name: '电影', icon: 'ri-film-line', slug: 'dianying', description: '最新院线大片、经典电影合集' },
  { id: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', slug: 'dianshiju', description: '热门国产剧、海外剧集' },
  { id: 'zongyi', name: '综艺', icon: 'ri-live-line', slug: 'zongyi', description: '热门综艺、真人秀节目' },
  { id: 'dongman', name: '动漫', icon: 'ri-rocket-line', slug: 'dongman', description: '日本动漫、国产动画' },
  { id: 'jilupian', name: '纪录片', icon: 'ri-earth-line', slug: 'jilupian', description: '自然人文、历史探索' },
  { id: 'tiyu', name: '体育', icon: 'ri-basketball-line', slug: 'tiyu', description: '体育赛事、精彩集锦' },
] as const;

export const allContent = [
  {
    id: 1,
    title: '星际穿越',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20poster%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%2C%20cinematic%20lighting%20with%20deep%20space%20background%2C%20warm%20orange%20and%20dark%20blue%20tones%2C%20movie%20poster%20style%20with%20dramatic%20composition&width=800&height=450&seq=content-01&orientation=landscape',
    rating: 9.4,
    year: 2014,
    description: '一部震撼人心的科幻巨作，讲述人类在面临灭绝危机时，穿越虫洞寻找新家园的壮丽旅程。导演诺兰以惊人的视觉呈现和深刻的情感内核，打造了这部现代科幻经典。',
    duration: '169分钟',
    director: '克里斯托弗·诺兰',
    tags: ['科幻', '冒险', '人性', '太空'],
    views: 12580000,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '流浪地球2',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20poster%20showing%20Earth%20with%20massive%20engines%20propelling%20through%20space%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20epic%20cinematic%20scale%2C%20futuristic%20technology%20visuals&width=800&height=450&seq=content-02&orientation=landscape',
    rating: 8.3,
    year: 2023,
    description: '中国科幻电影里程碑之作的续集，讲述人类在太阳危机面前团结一致，启动"流浪地球计划"的宏大故事。视觉特效达到国际顶尖水准。',
    duration: '173分钟',
    director: '郭帆',
    tags: ['科幻', '灾难', '国产', '太空'],
    views: 9800000,
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '繁花',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20stylish%20Chinese%20drama%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20nostalgic%20atmosphere%20with%20elegant%20composition&width=800&height=450&seq=content-03&orientation=landscape',
    rating: 8.7,
    year: 2023,
    description: '王家卫首部电视剧作品，以上世纪九十年代的上海为背景，讲述阿宝从平凡青年到商界翘楚的传奇人生。极致的美学风格，精湛的演员表演。',
    duration: '30集',
    director: '王家卫',
    tags: ['剧情', '年代', '商战', '爱情'],
    views: 15200000,
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '狂飙',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20scene%20with%20two%20men%20facing%20each%20other%20in%20a%20dimly%20lit%20room%2C%20intense%20atmosphere%2C%20Chinese%20police%20drama%20aesthetic%2C%20moody%20lighting%20with%20deep%20shadows&width=800&height=450&seq=content-04&orientation=landscape',
    rating: 8.5,
    year: 2023,
    description: '一部横跨二十年的扫黑除恶题材剧集，以刑警安欣与黑恶势力高启强的正邪较量为主线，深刻展现了中国社会变迁中的人性挣扎与正义坚守。',
    duration: '39集',
    director: '徐纪周',
    tags: ['犯罪', '剧情', '扫黑', '悬疑'],
    views: 18500000,
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '乘风破浪的姐姐',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20elegant%20mature%20women%20performers%20on%20a%20glamorous%20stage%20with%20sparkling%20lights%2C%20Chinese%20variety%20show%20aesthetic%2C%20vibrant%20golden%20and%20pink%20staging%2C%20empowering%20atmosphere&width=800&height=450&seq=content-05&orientation=landscape',
    rating: 8.1,
    year: 2023,
    description: '30岁以上女艺人的舞台竞演节目，展现成熟女性的独特魅力与无限可能。姐姐们在舞台上突破自我，绽放耀眼光芒。',
    duration: '12期',
    director: '芒果TV',
    tags: ['音乐', '竞演', '女性', '励志'],
    views: 10200000,
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '向往的生活',
    category: 'zongyi',
    categoryName: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20courtyard%20with%20wooden%20house%20and%20green%20fields%2C%20warm%20sunset%20lighting%2C%20Chinese%20rural%20lifestyle%20scene%2C%20cozy%20and%20natural%20atmosphere%20with%20farm%20animals&width=800&height=450&seq=content-06&orientation=landscape',
    rating: 8.4,
    year: 2023,
    description: '一档回归田园生活的慢综艺，嘉宾们在乡间小院自给自足，用劳动换取食材，招待远道而来的朋友。温暖治愈，充满人情味。',
    duration: '14期',
    director: '湖南卫视',
    tags: ['生活', '慢综艺', '美食', '田园'],
    views: 8900000,
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '鬼灭之刃 锻刀村篇',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20scene%20with%20swordsman%20fighting%20demons%20in%20a%20traditional%20village%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20dark%20tones%2C%20anime%20art%20style%20with%20dramatic%20lighting%20effects&width=800&height=450&seq=content-07&orientation=landscape',
    rating: 9.2,
    year: 2023,
    description: '现象级日本动漫最新篇章，炭治郎前往锻刀村修复日轮刀，却遭遇上弦之鬼的突袭。极致华丽的战斗场面，感人至深的情感刻画。',
    duration: '11集',
    director: '外崎春雄',
    tags: ['热血', '战斗', '奇幻', '日漫'],
    views: 11500000,
    isHot: true,
    isNew: true,
  },
  {
    id: 8,
    title: '蓝色星球2',
    category: 'jilupian',
    categoryName: '纪录片',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20scene%20with%20colorful%20coral%20reef%20and%20diverse%20marine%20life%2C%20crystal%20clear%20blue%20water%2C%20BBC%20nature%20documentary%20style%2C%20ray%20of%20sunlight%20penetrating%20the%20ocean%20surface&width=800&height=450&seq=content-08&orientation=landscape',
    rating: 9.8,
    year: 2017,
    description: 'BBC出品的殿堂级自然纪录片，带你潜入深海，探索地球最后的未知领域。每一帧都可以做壁纸的绝美画面，揭示海洋世界的神奇与脆弱。',
    duration: '7集',
    director: 'BBC Earth',
    tags: ['自然', '海洋', 'BBC', '探索'],
    views: 7600000,
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: 'NBA总决赛精彩集锦',
    category: 'tiyu',
    categoryName: '体育',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20with%20player%20dunking%20the%20ball%2C%20packed%20arena%20with%20dramatic%20stadium%20lighting%2C%20intense%20sports%20photography%20style%2C%20dynamic%20movement%20captured&width=800&height=450&seq=content-09&orientation=landscape',
    rating: 9.1,
    year: 2024,
    description: 'NBA总决赛巅峰对决全收录，赛季最精彩的高光时刻。扣篮、绝杀、逆天翻盘，每一秒都让人热血沸腾。',
    duration: '120分钟',
    director: 'NBA官方',
    tags: ['篮球', 'NBA', '集锦', '竞技'],
    views: 13500000,
    isHot: true,
    isNew: true,
  },
  {
    id: 10,
    title: '奥本海默',
    category: 'dianying',
    categoryName: '电影',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20portrait%20of%20a%20scientist%20silhouetted%20against%20a%20massive%20nuclear%20explosion%20mushroom%20cloud%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20cinematic%20biographical%20film%20aesthetic&width=800&height=450&seq=content-10&orientation=landscape',
    rating: 8.8,
    year: 2023,
    description: '诺兰又一力作，讲述"原子弹之父"奥本海默的传奇人生。从曼哈顿计划到战后的道德困境，一部关于科学、权力与良知的史诗巨制。',
    duration: '180分钟',
    director: '克里斯托弗·诺兰',
    tags: ['传记', '历史', '战争', '剧情'],
    views: 10800000,
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '三体',
    category: 'dianshiju',
    categoryName: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20alien%20civilization%20signal%20being%20received%20at%20a%20giant%20radio%20telescope%20under%20starry%20night%20sky%2C%20Chinese%20sci-fi%20drama%20aesthetic%2C%20cool%20blue%20and%20silver%20tones%2C%20cosmic%20scale&width=800&height=450&seq=content-11&orientation=landscape',
    rating: 8.0,
    year: 2023,
    description: '根据刘慈欣雨果奖获奖小说改编，讲述地球人类文明与三体文明的首次接触与生死博弈。宏大的宇宙观，震撼的科幻想象。',
    duration: '30集',
    director: '杨磊',
    tags: ['科幻', '小说改编', '宇宙', '悬疑'],
    views: 14200000,
    isHot: true,
    isNew: true,
  },
  {
    id: 12,
    title: '咒术回战 第二季',
    category: 'dongman',
    categoryName: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Anime%20character%20with%20white%20hair%20and%20blindfold%20fighting%20with%20supernatural%20powers%2C%20dynamic%20action%20scene%20with%20blue%20energy%20effects%2C%20Japanese%20animation%20style%2C%20urban%20Tokyo%20background&width=800&height=450&seq=content-12&orientation=landscape',
    rating: 9.0,
    year: 2023,
    description: '人气动漫续作，讲述五条悟与夏油杰在高专时期的青春往事。涩谷事变篇更是将剧情推向高潮，战斗场面燃到极致。',
    duration: '23集',
    director: '朴性厚',
    tags: ['热血', '战斗', '日漫', '超能力'],
    views: 16200000,
    isHot: true,
    isNew: true,
  },
];

export const faqItems = [
  {
    question: '极速高清需要下载APP才能观看吗？',
    answer: '不需要！极速高清支持网页端直接在线观看，无需下载任何APP或插件。只需打开浏览器，即可畅享高清视频内容。同时完美适配手机、平板、电脑等多种设备。',
  },
  {
    question: '在线观看的画质如何？是否支持高清？',
    answer: '我们提供720P至4K多种清晰度可选，默认播放高清画质。系统会根据您的网络状况智能调节码率，确保流畅的在线观看体验。所有内容均经过专业转码优化。',
  },
  {
    question: '在线观看会消耗很多流量吗？',
    answer: '我们采用先进的视频压缩技术，在保证画质的同时最大限度节省流量。您也可以在播放设置中选择标清模式以进一步节省流量。建议在WiFi环境下享受最佳画质。',
  },
  {
    question: '极速高清的内容是免费的吗？',
    answer: '平台大部分内容均可免费在线观看。我们通过少量优质广告维持平台运营，保证为您持续提供高质量的视频内容服务。',
  },
  {
    question: '支持哪些设备在线观看？',
    answer: '极速高清全面支持手机（iOS/Android）、平板、笔记本、台式电脑、智能电视等多种设备。一个账号，全平台同步观看记录和收藏内容。',
  },
  {
    question: '遇到播放卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议您：1）检查网络连接是否稳定；2）手动切换到较低清晰度；3）关闭其他占用带宽的应用；4）刷新页面重新加载。如问题持续，请联系客服获取帮助。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20clean%20studio%20lighting%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '用了极速高清半年多了，画质真的没话说，尤其是4K专区的内容，在大电视上看太震撼了！加载速度也很快，基本不用缓冲。',
    date: '2024年6月',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20clean%20studio%20lighting%2C%20warm%20smile&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '每天晚上睡前都要刷一波综艺，极速高清的综艺更新太及时了！而且分类很清晰，找节目特别方便。手机观看的体验也一级棒。',
    date: '2024年7月',
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20headshot%20on%20plain%20light%20gray%20background%2C%20clean%20studio%20lighting%2C%20casual%20look&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    comment: '作为一个动漫迷，这里的动漫资源真的全！新番更新速度很快，画质也好，而且没有那些乱七八糟的弹窗广告，看番体验满分。',
    date: '2024年6月',
  },
];

export const statsData = [
  { value: '5000万+', label: '月活跃用户' },
  { value: '10万+', label: '视频资源' },
  { value: '99.9%', label: '服务可用率' },
  { value: '150+', label: '覆盖国家地区' },
];

export const brandHistory = [
  { year: '2018', event: '极速高清正式成立，以"让每个人都能畅享高清视频"为使命出发' },
  { year: '2019', event: '平台月活跃用户突破100万，完成A轮融资' },
  { year: '2020', event: '推出4K超高清专区，成为行业画质标杆' },
  { year: '2021', event: '全面覆盖移动端，月活用户突破1000万' },
  { year: '2022', event: '获得"最佳在线视频平台"行业大奖' },
  { year: '2023', event: 'AI智能推荐系统上线，月活用户突破5000万' },
  { year: '2024', event: '推出8K超高清体验专区，持续引领行业创新' },
];